import { HTTP_TOKEN } from "./http";

export const getCustomConversions = (params) => {
  return HTTP_TOKEN.get("custom-conversion", { params }).then((result) => {
    return result.data;
  });
};

export const getCustomConversion = (customCId) => {
  return HTTP_TOKEN.get(`custom-conversion/${customCId}`).then((result) => {
    return result.data;
  });
};

export const createCustomConversion = (data) => {
  return HTTP_TOKEN.post("custom-conversion", data).then((result) => {
    return result.data;
  });
};

export const updateCustomConversion = (customCId, params) => {
  return HTTP_TOKEN.put(`custom-conversion/${customCId}`, params).then((result) => {
    return result.data;
  });
};

export const deleteCustomConversion = (customCId) => {
  return HTTP_TOKEN.delete(`custom-conversion/${customCId}`, {}).then((result) => {
    return result.data;
  });
};

// actives
export const getCustomConversionActives = (customId, params) => {
  return HTTP_TOKEN.get(`custom-conversion/${customId}/active`, { params }).then((result) => {
    return result.data;
  });
};

export const getCustomConversionActive = (customId, activeId) => {
  return HTTP_TOKEN.get(`custom-conversion/${customId}/active/${activeId}`).then((result) => {
    return result.data;
  });
};

export const createCustomConversionActive = (customId, data) => {
  return HTTP_TOKEN.post(`custom-conversion/${customId}/active`, data).then((result) => {
    return result.data;
  });
};

export const updateCustomConversionActive = (customId, activeId, data) => {
  return HTTP_TOKEN.put(`custom-conversion/${customId}/active/${activeId}`, data).then((result) => {
    return result.data;
  });
};

export const deleteCustomConversionActive = (customId, activeId) => {
  return HTTP_TOKEN.delete(`custom-conversion/${customId}/active/${activeId}`, {}).then((result) => {
    return result.data;
  });
};